<div class="logout-container">
  <button class="logout-button" (click)="logout()">🔒 Déconnexion</button>
</div>

<!-- DERNIER RAPPORT -->
<div *ngIf="lastReportUrl" class="dashboard-section report-section">
  <div class="report-background"></div>
  <div class="dashboard-header">
    <h2 class="dashboard-title">
      Dernier rapport quotidien :
      <button class="report-download-btn" (click)="downloadLastReport()">
        <img src="/assets/icons/download-icon.png" alt="Télécharger" />
        {{ lastReportName }}
      </button>
    </h2>
  </div>
</div>

<!-- SECTION QR CODES -->
<div class="dashboard-section">
  <div class="dashboard-header" (click)="toggleAccordion()" tabindex="0">
    <h2 class="dashboard-title">
      Vos QR Codes
      <span class="accordion-toggle">{{ isAccordionOpen ? '-' : '+' }}</span>
    </h2>
  </div>

  <div *ngIf="isAccordionOpen" class="accordion-content">
    <p class="dashboard-subtitle">Codes générés pour votre établissement</p>

    <!--
<button class="qr-add-button" (click)="generateRandomQrCode()" [disabled]="isGenerating">
  <span *ngIf="isGenerating">Création...</span>
  <span *ngIf="!isGenerating">➕ Ajouter un QR Code</span>
</button>
-->

    <div *ngIf="qrCodes.length === 0" class="dashboard-empty">
      Aucun QR Code généré pour le moment.
    </div>

    <div class="qr-action-bar" *ngIf="selectedQrCodes.size >= 2">
      <button (click)="downloadSelectedQrCodes()" [disabled]="isDownloadingZip">
        <img src="/assets/icons/download-icon.png" alt="Télécharger" />
      </button>
      <button (click)="deleteSelectedQrCodes()">
        <img src="/assets/icons/delete-icon.png" alt="Supprimer" />
      </button>
    </div>

    <div *ngIf="isDownloadingZip || isDownloadingQr" class="dashboard-subtitle">
      Téléchargement en cours...
    </div>

    <div class="qr-grid">
      <div class="qr-card" *ngFor="let qr of qrCodes">
        <input
          type="checkbox"
          class="qr-checkbox"
          [checked]="isSelected(qr.folderName)"
          (change)="toggleSelection(qr.folderName)"
        />
        <div class="qr-icon">
          <img src="/assets/icons/qr-code-icon.png" alt="QR Code" />
        </div>
        <input class="qr-name-input" [(ngModel)]="qr.qrCodeName" (change)="updateQrCodeName(qr)" />
        <div class="qr-actions">
          <button class="qr-download-button" (click)="downloadQrCode(qr)">
            <img src="/assets/icons/download-icon.png" alt="Télécharger" width="20" height="20" />
          </button>
          <button class="qr-delete-button" (click)="deleteQrCode(qr)">
            <img src="/assets/icons/delete-icon.png" alt="Supprimer" width="20" height="20" />
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- SECTION TÂCHES ET HORAIRES -->
<div class="dashboard-section tasks-section">
  <div class="tasks-background"></div>
  <div class="dashboard-header" (click)="toggleTasksAccordion()" tabindex="0">
    <h2 class="dashboard-title">
      Vos tâches et horaires de rondes
      <span class="accordion-toggle">{{ isTasksAccordionOpen ? '-' : '+' }}</span>
    </h2>
  </div>

  <div *ngIf="isTasksAccordionOpen" class="accordion-content">
    <p class="dashboard-subtitle">Liste des actions prévues pour chaque ronde</p>

    <div *ngIf="isLoadingTasksAndRounds" class="dashboard-empty">Chargement...</div>

    <div
      *ngIf="!isLoadingTasksAndRounds && tasks.length === 0 && roundTimes.length === 0"
      class="dashboard-empty"
    >
      Aucune tâche ni horaire défini pour l’instant.
    </div>

    <div class="task-rounds-wrapper" *ngIf="tasks.length > 0 || roundTimes.length > 0">
      <div *ngIf="tasks.length > 0" class="task-round-column">
        <h3 class="dashboard-subtitle">📝 Tâches</h3>
        <ul class="task-list">
          <li *ngFor="let task of tasks">{{ task.task }}</li>
        </ul>
      </div>

      <div *ngIf="roundTimes.length > 0" class="task-round-column">
        <h3 class="dashboard-subtitle">⏰ Horaires de rondes</h3>
        <ul class="task-list">
          <li *ngFor="let round of roundTimes">{{ round.time }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- SECTION RONDIERS -->
<div class="dashboard-section rondier-section">
  <div class="dashboard-header" (click)="toggleGuardsAccordion()" tabindex="0">
    <h2 class="dashboard-title">
      Vos rondiers
      <span class="accordion-toggle">{{ isGuardsAccordionOpen ? '-' : '+' }}</span>
    </h2>
  </div>

  <div *ngIf="isGuardsAccordionOpen" class="accordion-content">
    <p class="dashboard-subtitle">Liste des rondiers affectés à votre établissement</p>

    <div *ngIf="isLoadingGuards" class="dashboard-empty">Chargement...</div>

    <div *ngIf="!isLoadingGuards && guards.length === 0" class="dashboard-empty">
      Aucun rondier enregistré pour le moment.
    </div>

    <div class="rondier-grid" *ngIf="guards.length > 0">
      <div class="rondier-card" *ngFor="let guard of guards">
        <div class="rondier-avatar">
          <img src="/assets/icons/personnage.png" alt="Rondier" />
        </div>
        <div class="rondier-name">{{ guard.name }}</div>
      </div>
    </div>
  </div>
</div>

<!-- POPUP LIMITE -->
<div *ngIf="showUpgradePopup" class="popup-overlay">
  <div class="popup-content">
    <h3>Limite atteinte</h3>
    <p>Vous avez atteint la limite de {{ maxQrCodes }} QR codes pour votre formule actuelle.</p>
    <p>Pour en ajouter davantage, veuillez passer à un plan supérieur.</p>
    <button (click)="closePopup()">OK</button>
  </div>
</div>
